import { Link } from 'react-router-dom';
import Logo from '../../../../common/assets/images/Logo-Benefit-Edenred.svg';
import Account from './components/AccountMenuItem';
import Language from './components/LanguageMenuItem';

export const Header = () => {
  return (
    <header className="app-bar m-app-bar">
      <div className="container">
        <div className="app-bar-branding">
          <Link to="/">
            <img src={Logo} alt="Logo Benefit Edenred" />
          </Link>
        </div>

        <div className="app-bar-tools">
          <Language />
          <Account />
        </div>
      </div>
    </header>
  );
};
